import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { inject, Service } from '@angular/core';

@Service()
export class AyudaService {
    private http = inject(HttpClient);
    public getAyuda() {
        return this.http.get(environment.apiUrl + '/api/ayuda', { responseType: 'text' });
    }
}
